export interface IStyleConfiguration {
  zoomFactor?: number
}

export function validateZoomFactor(zoom?: number): number {
  if (!zoom || typeof zoom !== 'number' || isNaN(zoom)) {
    return 1.0
  }
  // Clamp between 0.5 and 2.0 for reasonable sizing
  return Math.max(0.5, Math.min(2.0, zoom))
}
